<template>
  <div class="download-page" v-title data-title="雪松课堂APP下载">
    <header class="g-header-container">
      <div class="g-navbar">
        <h1 class="g-navbar-title">
          <span class="g-navbar-text">雪松课堂APP下载</span>
        </h1>
      </div>
    </header>
    <main class="g-view-container">
      <c-slider>
        <template v-for="(item, index) in details">
          <swiper-slide :key="index">
            <img class="detail" :src="item" />
          </swiper-slide>
        </template>
      </c-slider>
      <div class="content">
        <h2 class="title">雪松课堂APP，学习原来如此简单！</h2>
        <div class="btn-download" @click="download">点击下载APP</div>
      </div>

      <div class="footer">
        <p class="text">Copyright © 雪松课堂</p>
      </div>
    </main>
  </div>
</template>

<script>
  import CSlider from 'base/slider';
  import judgeClient from 'assets/js/judgeClient';
  import { xskt } from '../config';

  export default {
    name: 'xsktDownload',
    components: {
      CSlider,
    },
    created() {
      this.details = xskt.detail;
    },
    methods: {
      download() {
        const ua = judgeClient();
        if (ua === 'Android') {
          window.location.href = xskt.androidUrl;
        } else if (ua === 'iOS') {
          // window.location.href = xskt.iosUrl;
          this.$toast('等待开放');
        } else {
          window.location.href = xskt.androidUrl;
        }
      },
    },
  };
</script>

<style lang="scss" scoped>
@import "~assets/scss/mixins";

.g-view-container {
  position: relative;
  padding-bottom: 16px;
  @include flex-between(column);
}

.swiper-container {
  width: 100%;

  .detail {
    width: 100%;
  }

  ::v-deep .swiper-pagination {
    bottom: -1px;
  }
}

.content {
  margin-top: 10px;
  width: 100%;
  flex: 1;

  .title {
    font-size: 14px;
    color: #333;
    text-align: center;
    line-height: 3;
  }

  .btn-download {
    margin: 0 auto;
    width: 90%;
    height: 40px;
    line-height: 40px;
    font-size: 14px;
    letter-spacing: 1px;
    color: #fff;
    text-align: center;
    background: #17B47B;
    border-radius: 4px;
  }
}

.footer {
  text-align: center;
  line-height: 1.75;

  .link {
    color: #576b95;
  }

  .text {
    color: rgba(0, 0, 0, 0.3);
  }
}

::v-deep .swiper-pagination-bullet-active {
  background-color: #17B47B;
}
</style>
